"use client"

import { useState } from "react"
import { Button } from "@heroui/button"

import SignInModal from "@/components/home/sign-in"

export default function SignInButton() {
  const [showDiv, setShowDiv] = useState(false)
  return (
    <>
      <Button
        variant="solid"
        size="sm"
        className="border-small min-w-[128px] rounded-[4px] bg-[#1d2129] text-[14px] font-medium text-white"
        type="submit"
        radius="sm"
        onPress={() => setShowDiv(!showDiv)}
      >
        <span>Log In / Sign Up</span>
      </Button>
      {showDiv && <SignInModal isOpen={showDiv} onOpenChange={setShowDiv} />}
    </>
  )
}
